import React, { useState, useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { toggleSubmitActive } from '../../../../redux/testPage/testPage.actions';
const LinkedOptions = ({
	rightSectionProps: { prompt },
	questions,
	questionNo,
	toggleSubmitActive,
}) => {
	const [activeQue, setActiveQue] = useState(-1);
	const [selectedChoices, setSelectedChoices] = useState({});
	useEffect(() => {
		setSelectedChoices({});
		setActiveQue(-1);
	}, [questions, questionNo]);

	useEffect(() => {
		if (Object.keys(selectedChoices).length === Object.keys(questions).length) {
			setActiveQue(-1);
			toggleSubmitActive(false);
		} else if (Object.keys(selectedChoices).length > 0) {
			Object.keys(questions).some((que) => {
				if (!selectedChoices[que]) {
					setActiveQue(que);
					return true;
				}
				return null;
			});
		}
	}, [questions, selectedChoices, setActiveQue, toggleSubmitActive]);

	const handleSelect = (selectedIndex) => {
		setActiveQue(selectedIndex);
	};

	const ContextToggle = ({ children, eventKey, callback }) => {
		const currentEventKey = useContext(AccordionContext);

		const decoratedOnClick = useAccordionToggle(
			eventKey,
			() => callback && callback(eventKey),
		);

		const isCurrentEventKey = currentEventKey === eventKey;

		return (
			<div onClick={decoratedOnClick}>
				{children}
				<i
					className={`${
						isCurrentEventKey ? 'flipped' : ''
					} arrowpanel fa fa-angle-down`}
				></i>
			</div>
		);
	};

	//choices HTML
	let choiceListBody = '';
	if (typeof questions !== 'undefined') {
		choiceListBody = Object.keys(questions).map((que) => {
			const { choices } = questions[que];

			if (typeof choices !== 'undefined') {
				let Choicelist = Object.keys(choices).map(function (choice) {
					if (choices[choice] === '') {
						return false;
					}

					return (
						<li
							key={`choice_${choice}_${que}`}
							onClick={() =>
								setSelectedChoices((prev) => ({ ...prev, [que]: choices[choice] }))
							}
							className={`${
								!!selectedChoices[que] && selectedChoices[que] === choices[choice]
									? 'active'
									: ''
							}`}
						>
							{`${choices[choice]}`}
							<input
								title={que}
								type="text"
								style={{ display: 'none' }}
								defaultValue={`${choices[choice]}`}
								required
							/>
						</li>
					);
				});

				return Choicelist;
			} else return null;
		});
	}
	//Questions HTML

	let body = '';
	if (typeof questions !== 'undefined') {
		body = Object.keys(questions).map((que) => {
			return (
				<span key={`container-${que}-${questionNo}`}>
					<Card>
						<Card.Header>
							<ContextToggle className="text-left" eventKey={`${parseInt(que, 10)}`}>
								{' '}
								{`Question #${parseInt(que, 10) + 1}`}
								<h4>{questions[que].question} </h4>
								<div
									key={`question-${que}-${questionNo}`}
									style={{ display: `${!!selectedChoices[que] ? 'block' : 'none'}` }}
									className="answeredMark"
								>
									{' '}
									<i className="fa fa-check"></i> Answered
								</div>
							</ContextToggle>
						</Card.Header>

						<Accordion.Collapse eventKey={`${parseInt(que, 10)}`}>
							<Card.Body>
								<section className="quiz-area-options" id={`${que}`}>
									<h4>Choose</h4>
									<ul id={`ques-collapse-${que}`}>{choiceListBody[que]}</ul>
									{/* onClick={() => setActiveQue(`${parseInt(que, 10) + 1}`)} */}
									<input
										type="hidden"
										name="choosen-answer"
										className="choosen-answer"
									/>
								</section>
							</Card.Body>
						</Accordion.Collapse>
					</Card>
					<br />
				</span>
			);
		});
	}

	return (
		<span>
			<b dangerouslySetInnerHTML={{ __html: prompt }}></b>
			<div id="quiz-page-accordion linked-question">
				<Accordion
					activeKey={activeQue}
					onSelect={handleSelect}
					style={{ marginTop: '15px' }}
				>
					{body}
				</Accordion>
			</div>
		</span>
	);
};

const mapStateToProps = (state) => {
	const {
		rightSectionProps,
		questionNo,
		questions,
	} = state.rootReducer.testPageDetails;

	return {
		rightSectionProps,
		questionNo,
		questions,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		toggleSubmitActive: (val) => dispatch(toggleSubmitActive(val)),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(LinkedOptions);
